<div (scroll)="scrollBar($event)" (wheel)="onScroll($event)" [ngClass]="[paging !== 'virtual-scroll' ? '' : 'virtual-scroll', paging !== 'scroll' ? '' : 'scroll']">
  <ng-content></ng-content>
</div>
